import { useFormikContext } from "formik";
const useCurrentQueryString = () => {
  var _a;
  const { values } = useFormikContext();
  return (_a = values == null ? void 0 : values.queryString) != null ? _a : "";
};
export default useCurrentQueryString;
